import { PlannerItemResponse } from '@/types/Planner'
import { formatDate } from '@/util'
import { getPlannerItemsForDay } from '@/util/PlannerUtil'

export interface DayType {
  date: string | null
  day: string | null
  fullDate: string | null
  month: string | null
  tasks: PlannerItemResponse[]
}

export function getWeeklyList(
  startWeekDate: Date | null,
  endWeekDate: Date | null,
  plannerData: PlannerItemResponse[] | undefined,
) {
  if (!plannerData) return []
  if (startWeekDate && endWeekDate && startWeekDate < endWeekDate) {
    const weekDayList: DayType[] = []

    for (let i = new Date(startWeekDate); i <= endWeekDate; i.setDate(i.getDate() + 1)) {
      weekDayList.push({
        date: formatDate(i, 'dd'),
        month: formatDate(i, 'MMM'),
        day: formatDate(i, 'EEE'),
        fullDate: formatDate(i, 'yyyy-MM-dd'),
        tasks: getPlannerItemsForDay(plannerData, i),
      })
    }

    return weekDayList
  }
  return []
}
